module.exports = __webpack_public_path__ + "img/port.10cdb12d.svg";